import Draggable from "react-draggable";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { FaTimesCircle } from "react-icons/fa";
import { MeetingAttendeesList } from "./MeetingAttendeesList";

function FloatingParticipants({
  showParticipants,
  setShowParticipants,
  ...props
}) {
  const containerBgColor = useColorModeValue("#fff", "#07182E");

  return (
    showParticipants && (
      <Draggable>
        <Flex
          position={"relative"}
          zIndex="19800"
          bg={containerBgColor}
          boxShadow="lg"
          w="350px"
          maxW="350px"
          flexDirection={"column"}
          p="15px"
          borderRadius={"20px"}
          {...props}
        >
          <Flex justifyContent={"space-between"} mb="10px">
            <Box w="30px" />
            <Text fontWeight={"800"} fontSize="1.2em">
              Participants
            </Text>

            <FaTimesCircle
              cursor={"pointer"}
              color="#ADADAD"
              fontSize={"1.5em"}
              onClick={() => setShowParticipants(false)}
            />
          </Flex>
          <Flex
            flexDirection={"column"}
            gap="20px"
            overflowY={"scroll"}
            className="scroll-container"
            // mb="20px"
          >
            <MeetingAttendeesList
              p="0"
              onlyShowParticipants={true}
              list={[1, 2, 4, 3, 5, 6, 7, 8, 9, 0, 12, 3, 4, 5, 6, 7, 8, 9]}
            />
          </Flex>
        </Flex>
      </Draggable>
    )
  );
}

export default FloatingParticipants;
